import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Container, Heading3, Jumbo, Paragraph, Radio, Separator, tokens } from '@treams/treams-ui';

import SSOCreateAzure from './SSOCreateAzure';
import SSOCreateGoogle from './SSOCreateGoogle';

export default function SSOCreate() {
	const { t } = useTranslation();
	const [idp, setIdp] = useState<'azure' | 'google' | undefined>();

	return (
		<>
			<Jumbo
				title={t('settings.integrations.sso.create.title')}
				// description={t('settings.integrations.sso.create.description')}
				footer={<Separator />}
				backButtonLink="/settings/integrations/sso"
			/>
			<Container pt={`${tokens.gap.page}px`} pb={4}>
				<Box mb={3}>
					<Heading3>1. Maak een keuze tussen Azure of Google Workspace</Heading3>
					<Box mt={2}>
						<Flex>
							<Box mr={2}>
								<Radio.Card
									checked={idp === 'azure'}
									onChange={() => setIdp('azure')}
									title="Azure"
								/>
							</Box>
							<Radio.Card
								checked={idp === 'google'}
								onChange={() => setIdp('google')}
								title="Google Workspace"
							/>
						</Flex>
					</Box>
				</Box>
				{idp === undefined ? (
					<Box mb={3}>
						<Paragraph></Paragraph>
					</Box>
				) : idp === 'azure' ? (
					<SSOCreateAzure />
				) : (
					<SSOCreateGoogle />
				)}
			</Container>
		</>
	);
}
